module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-form', {
    ref: "form",
    model: {
      value: (_vm.formularioValido),
      callback: function($$v) {
        _vm.formularioValido = $$v
      },
      expression: "formularioValido"
    }
  }, [_c('v-container', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "tituloSecao"
  }, [_c('label', [_vm._v("Contatos do coordenador (disponíveis apenas para os administradores)")])])])], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "E-mail*",
      "counter": "100",
      "rules": _vm.obrigatorio.concat( _vm.max100caracteres, _vm.email)
    },
    model: {
      value: (_vm.projetoPesquisa.emailCoordenador),
      callback: function($$v) {
        _vm.$set(_vm.projetoPesquisa, "emailCoordenador", $$v)
      },
      expression: "projetoPesquisa.emailCoordenador"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Telefone*",
      "counter": "50",
      "rules": _vm.obrigatorio.concat( _vm.max50caracteres)
    },
    model: {
      value: (_vm.projetoPesquisa.telefoneCoordenador),
      callback: function($$v) {
        _vm.$set(_vm.projetoPesquisa, "telefoneCoordenador", $$v)
      },
      expression: "projetoPesquisa.telefoneCoordenador"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "tituloSecao"
  }, [_c('label', [_vm._v("Contatos do projeto de pesquisa (as informações de contato abaixo ficarão disponíveis para a consulta pública)")])])])], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Nome do contato*",
      "counter": "200",
      "rules": _vm.obrigatorio.concat( _vm.max200caracteres)
    },
    model: {
      value: (_vm.projetoPesquisa.nomeContato),
      callback: function($$v) {
        _vm.$set(_vm.projetoPesquisa, "nomeContato", $$v)
      },
      expression: "projetoPesquisa.nomeContato"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "E-mail*",
      "counter": "100",
      "rules": _vm.obrigatorio.concat( _vm.max100caracteres, _vm.email)
    },
    model: {
      value: (_vm.projetoPesquisa.emailContato),
      callback: function($$v) {
        _vm.$set(_vm.projetoPesquisa, "emailContato", $$v)
      },
      expression: "projetoPesquisa.emailContato"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Telefone*",
      "counter": "50",
      "rules": _vm.obrigatorio.concat( _vm.max50caracteres)
    },
    model: {
      value: (_vm.projetoPesquisa.telefoneContato),
      callback: function($$v) {
        _vm.$set(_vm.projetoPesquisa, "telefoneContato", $$v)
      },
      expression: "projetoPesquisa.telefoneContato"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Site",
      "counter": "50",
      "rules": _vm.max50caracteres
    },
    model: {
      value: (_vm.projetoPesquisa.site),
      callback: function($$v) {
        _vm.$set(_vm.projetoPesquisa, "site", $$v)
      },
      expression: "projetoPesquisa.site"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-textarea', {
    attrs: {
      "label": "Mídias sociais",
      "rows": "1",
      "auto-grow": "",
      "counter": "100",
      "rules": _vm.max100caracteres
    },
    model: {
      value: (_vm.projetoPesquisa.midiasSociais),
      callback: function($$v) {
        _vm.$set(_vm.projetoPesquisa, "midiasSociais", $$v)
      },
      expression: "projetoPesquisa.midiasSociais"
    }
  })], 1)], 1), _vm._v(" "), _c('br')], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.cancelar()
      }
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "disabled": !_vm.formularioValido
    },
    on: {
      "click": function($event) {
        return _vm.editarProjetoPesquisa()
      }
    }
  }, [_vm._v("Salvar")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bdcc4b8c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/pesquisa/editar-contatos.vue
// module id = 920
// module chunks = 0